import { render, staticRenderFns } from "./TomaUsados.vue?vue&type=template&id=0878fafe&scoped=true"
import script from "./TomaUsados.vue?vue&type=script&lang=js"
export * from "./TomaUsados.vue?vue&type=script&lang=js"
import style0 from "./TomaUsados.vue?vue&type=style&index=0&id=0878fafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878fafe",
  null
  
)

export default component.exports